<template>
  <div class="conference">
    <div class="card conference-card">
      <div class="card-body">
        <div class="row">
          <div class="card-col">
            <h4 class="mb-0">{{ conference.conference_name }}</h4>
            <p class="card-text">
              {{ dayjs(conference.conference_days[0].start).locale($i18n.locale).format("ddd MMM Do") }}
              -
              {{
                dayjs(
                  conference.conference_days[conference.conference_days.length - 1].start
                ).locale($i18n.locale).format("ddd MMM Do")
              }}
            </p>
            <!-- <p class="card-text text-muted">Description of the conference blah blah blah</p> -->
          
          </div>
          
          <div class="card-col">
            <a
              href=""
              role="button"
              class="btn btn-primary btn-meetings disabled"
              v-if="isClosed(conference) == -1"
              data-cy="goto-event-add-edit-meeting"
              data-disabled
              data-disabled-type="before"
              > {{ $t("message.ConferenceCard.opening") }} {{ dayjs(conference.open_tstamp).locale($i18n.locale).format("lll") }}</a
            >
            <a
              href=""
              role="button"
              class="btn btn-primary btn-meetings disabled"
              v-if="isClosed(conference) == 1"
              data-cy="goto-event-add-edit-meeting"
              data-disabled
              data-disabled-type="after"
              >{{ $t("message.ConferenceCard.closed") }} {{ dayjs(conference.closed_tstamp).locale($i18n.locale).format("lll") }}</a
            >

            <router-link
              :to="{
                name: 'parent-matrix',
                params: {
                  account: $route.params.account,
                  id: conference.conference_id
                }
              }"
              role="button"
              class="btn btn-primary btn-meetings"
              @click="selectConference(conference)"
              v-if="isClosed(conference) == 0"
              data-cy="goto-event-add-edit-meeting"
            >
              <span>{{ $t('message.ConferenceCard.add_edit_meetings') }}</span>
            </router-link>
          </div>
        </div>

        <AgendaCard v-if="agenda" :conference="conference" />
      </div>
    </div>
  </div>
</template>
<script setup>
import AgendaCard from "@/components/parent/AgendaCard.vue";
import { useConferenceStore } from "@/stores/parent/conference";
import { useTeacherStore } from "@/stores/parent/teacher";
import dayjs from "dayjs";
import advancedFormat from "dayjs/esm/plugin/advancedFormat";
import timezone from "dayjs/esm/plugin/timezone";
import utc from "dayjs/esm/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

const teacherStore = useTeacherStore();
const conferenceStore = useConferenceStore();
const props = defineProps({
  conference: Object,
  agenda: Boolean,
  school: Object
});
function isClosed(conference) {
  const now = dayjs().tz(props.school?.timezone);
  // Treat the stored timestamps as if they are in the school's timezone
  const start = dayjs.tz(conference?.open_tstamp, props.school?.timezone);
  const end = dayjs.tz(conference?.closed_tstamp, props.school?.timezone);
  if (now.isBefore(start)) {
    return -1;
  } else if (now.isAfter(end)) {
    return 1;
  } else {
    return 0;
  }
}

function selectConference(conference) {
  if (
    conferenceStore.selected &&
    conferenceStore.selected.conference_id != conference.conference_id
  ) {
    conferenceStore.selected = conference;
    conferenceStore.selectedDay = conference.conference_days[0];
    teacherStore.selected.forEach((teacher) => {
      delete teacher.value.checked;
      delete teacher.value.timeslots;
      delete teacher.value.conflicts;
    });
  } else {
    conferenceStore.selectedDay = conference.conference_days[0];
  }
  teacherStore.selected = [];
}
</script>
